export const POSTPONED_FIREBASE_EVENTS = 'postponed-firebase-events';
export const CONTINUE_PAGE_AFTER_AUTHORIZE = 'continue-page';
export const RESUME_SIGNUP_CODE = 'resume-signup-code';